import { createTheme } from "@mui/material";

export  const appTheme = createTheme({
    palette: {
        mode: 'light',
        primary: { main: "#006db8"}, 
        secondary: { main: "#f5f5f1"},
        text: { primary: "#77777"},
    }
})